import { Injectable } from '@angular/core';
import { async } from '@angular/core/testing';
import {
  getConnection,
  getCurrentUser,
  getEndpoint,
} from 'src/app/core/services/functions.service';
import { RequestsService } from 'src/app/core/services/requests.service';

@Injectable({
  providedIn: 'root',
})
export class CuotasService {
  c_emp = getConnection();
  user = getCurrentUser().usuario_aplicativo;
  urlBase = getEndpoint("CUOTAS")
  urlConsulta = getEndpoint("ConsultaPlanCuotas")
  constructor(private _RequestsService: RequestsService) { }

  consultar = async (rem) => {
    try {
      //Formatear valores de cuotas
      const options = {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
      };
      const numberFormat = new Intl.NumberFormat('en-US', options);
      console.log(rem)
      let resultDatosRem = await this._RequestsService.get(
        `${this.urlBase}/${this.c_emp}/transparencia/consultar/${rem}`
      );
      if (resultDatosRem.success) {
        let resultDatosCuotas = await this._RequestsService.get(`${this.urlConsulta}/${this.c_emp}/${rem}/${resultDatosRem.data.c_agr}/${resultDatosRem.data.per}`);
        resultDatosCuotas.data.map((r) => {
          r.cuota_pagar = numberFormat.format(r.cuota_pagar);
          r.capital_simular = numberFormat.format(r.capital_simular);
          r.total_interes = numberFormat.format(r.total_interes);
          r.total_seguro = numberFormat.format(r.total_seguro);
          r.tarifa_seguro = numberFormat.format(r.tarifa_seguro);
          r.tea = Number(r.tea / 100).toLocaleString(undefined, { style: 'percent', minimumFractionDigits: 2 });
        });
        const result = {
          resultDatosRem,
          resultDatosCuotas
        }
        return result;
      } else {
        return resultDatosRem.success
      }

    } catch (error) {
      return error;
    }
  };

  cambiar = async (plan, rem, cedula) => {
    try {
      let result = await this._RequestsService.postLikeJSON(
        `${this.urlBase}/${this.c_emp}/transparencia/plan/`,
        { cuotas: plan, rem: rem, user: this.user, cedula: cedula }
      );
      return result;
    } catch (error) {
      return error;
    }
  };
}

